import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\DossierNumbering\DeleteDossierNumberingController::deleteMethod
* @see app/Http/Controllers/DossierNumbering/DeleteDossierNumberingController.php
* @route '/api/dossier-numbering/{dossier_numbering}'
*/
export const deleteMethod = (args: { dossier_numbering: string | number | { id: string | number } } | [dossier_numbering: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/dossier-numbering/{dossier_numbering}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\DossierNumbering\DeleteDossierNumberingController::deleteMethod
* @see app/Http/Controllers/DossierNumbering/DeleteDossierNumberingController.php
* @route '/api/dossier-numbering/{dossier_numbering}'
*/
deleteMethod.url = (args: { dossier_numbering: string | number | { id: string | number } } | [dossier_numbering: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier_numbering: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier_numbering: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier_numbering: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier_numbering: typeof args.dossier_numbering === 'object'
        ? args.dossier_numbering.id
        : args.dossier_numbering,
    }

    return deleteMethod.definition.url
            .replace('{dossier_numbering}', parsedArgs.dossier_numbering.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DossierNumbering\DeleteDossierNumberingController::deleteMethod
* @see app/Http/Controllers/DossierNumbering/DeleteDossierNumberingController.php
* @route '/api/dossier-numbering/{dossier_numbering}'
*/
deleteMethod.delete = (args: { dossier_numbering: string | number | { id: string | number } } | [dossier_numbering: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\DossierNumbering\DeleteDossierNumberingController::undo
* @see app/Http/Controllers/DossierNumbering/DeleteDossierNumberingController.php
* @route '/api/dossier-numbering/{id}/undo-delete'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/dossier-numbering/{id}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DossierNumbering\DeleteDossierNumberingController::undo
* @see app/Http/Controllers/DossierNumbering/DeleteDossierNumberingController.php
* @route '/api/dossier-numbering/{id}/undo-delete'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DossierNumbering\DeleteDossierNumberingController::undo
* @see app/Http/Controllers/DossierNumbering/DeleteDossierNumberingController.php
* @route '/api/dossier-numbering/{id}/undo-delete'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DossierNumbering\DeleteDossierNumberingController::undo
* @see app/Http/Controllers/DossierNumbering/DeleteDossierNumberingController.php
* @route '/api/dossier-numbering/{id}/undo-delete'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteDossierNumberingController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteDossierNumberingController